<template>
  <box-model title="加工阶段占比情况">
    <template v-slot:content>
      <div class="container">
        <div id="echart" class="con"></div>
        <div class="show-part flex-y-center">
          <div class="sm">
            <div class="s-title">{{ new Date().getFullYear() }}<span style="font-size: 14px;line-height: 14px;font-weight: 400;margin-left: 6px;">年</span></div>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import echarts from 'echarts'
  import { getProcessRecordStage } from "@/api/index";
  export default {
    data() {
      return {
        option: {
          tooltip : {
            trigger: 'item',
            formatter: function(item){
              let result = `
                <div style="padding: 12px;z-index:1001">
                  <div style="color: #3E3E3E;font-size: 13px;">${item.name}</div>
                  <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                  <div style="display: flex;align-items: center;">
                    <div style="width: 8px;height: 8px;background: ${item.color};border-radius: 50%;"></div>
                    <div style="color: #000E2B;font-size: 13px;margin-left: 4px;line-height: 16px;">数量：${item.value}</div>  
                  </div>
                </div>
              `;
              return result;
            },
            backgroundColor: '#fff',
          },
          color:['#FF6637','#FFCC00','rgb(6,247,161)'],
          series: [
            {
              name: '资源总量构成',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['40%', '60%'],
              data:[
                {value:435, name:'加工中', color: '#FF6637'},
                {value:679, name:'加工完成', color: '#FFCC00'},
                {value:848, name:'质检完成', color: 'rgb(6,247,161)'},
              ],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              itemStyle: {
                normal: {
                  label:{ 
                    show: true, 
                    formatter: function(param) {
                      return `${param.name}：${param.percent}%`
                    },
                    fontSize : 10,
                  }
                },
                labelLine :{show:true}
              }
            }
          ]
        },
        detail: {}
      }
    }, 
    components: {
      "box-model": () => import("../../components/common/Model.vue")
    },
    mounted(){
      this.getProcessRecordStageFn();
    },
    methods: {
      init(option) {
        const myChart = echarts.init(document.getElementById("echart"));
        myChart.setOption(option);
      },
      getProcessRecordStageFn() {
        getProcessRecordStage({
          year: new Date().getFullYear()
        }).then((res) => {
          const result = res.data || {};
          this.detail = result;
          const option = {
            tooltip : {
              trigger: 'item',
              formatter: function(item){
                let result = `
                  <div style="padding: 12px;z-index:1001">
                    <div style="color: #3E3E3E;font-size: 15px;">${item.name}</div>
                    <div style="width: 100%;height: 1px;background: #E8E8EA;margin:8px 0; "></div>
                    <div style="display: flex;align-items: center;">
                      <div style="width: 8px;height: 8px;background: ${item.color};border-radius: 50%;"></div>
                      <div style="color: #000E2B;font-size: 15px;margin-left: 4px;line-height: 16px;">数量：${item.value}</div>  
                    </div>
                  </div>
                `;
                return result;
              },
              backgroundColor: '#fff',
            },
            color:['#FF6637','#FFCC00','rgb(6,247,161)'],
            series: [
              {
                name: '资源总量构成',
                type: 'pie',
                center: ['50%', '46%'],
                radius: ['50%', '66%'],
                data:[
                  {value: result.inProcessingNum || 0, name:'加工中', color: '#FF6637'},
                  {value: result.processingCompletionNum || 0, name:'加工完成', color: '#FFCC00'},
                  {value: result.inspected || 0, name:'质检完成', color: 'rgb(6,247,161)'},
                ],
                itemStyle: {
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                },
                itemStyle: {
                  normal: {
                    label:{ 
                      show: true, 
                      formatter: function(param) {
                        return `${param.name}：${param.percent}%`
                      },
                      fontSize : 10,
                    }
                  },
                  labelLine :{show:true}
                }
              }
            ]
          };
          this.init(option);
        })
      }
    }
  }
</script>
<style scoped lang="less">
  .container {
    position: relative;
    width: 100%;
    height: 220px;
    .con {
      position: relative;
      z-index: 0;
      width: 100%;
      height: 220px;
    }
    .show-part {
      position: absolute;
      z-index: 999;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 40%;
      height: 40%;
      .sm {
        width: 100%;
        .s-title {
          font-size: 22px;
          font-weight: 700;
          color: rgba(255,255,255,1);
          line-height: 15px;
          text-align: center;
        }
    }
    }
  }
</style>